import React, { FC } from 'react';
import { Container, ContentLoader } from './styles';

const Loader: FC = () => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 180 190">
        <rect x="12" y="17" rx="8" ry="8" width="100" height="15" />
        <rect x="12" y="53" rx="8" ry="8" width="80" height="15" />
        <rect x="12" y="89" rx="8" ry="8" width="60" height="15" />
        <rect x="12" y="124" rx="8" ry="8" width="80" height="15" />
        <rect x="12" y="158" rx="8" ry="8" width="100" height="15" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
